import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  isPrivacyPolicy,
  acceptPrivacyPolicy
} from './utils'


export default class extends PureComponent {
  static propTypes = {
  }
  static defaultProps = {
  }
  state = {
    isActive: isPrivacyPolicy(),
  }
  // ======================================================
  // Commit Phase
  // Can work with DOM, run side effects, schedule updates.
  // ======================================================
  componentDidMount = () => {
  }
  componentDidUpdate = (prevProps, prevState, snapshot) => {
  }
  componentWillUnmount = () => {
  }
  // ======================================================
  // Pre-commit Phase
  // Can read the DOM
  // ======================================================
  getSnapshotBeforeUpdate = (prevProps, prevState) => {
    return {}
  }
  // ======================================================
  // Render Phase
  // Pure and no side effects. May be paused, aborted or restarted by React.
  // ======================================================
  static getDerivedStateFromProps (props, state) {
    return {}
  }
  // ======================================================
  // Private Methods
  // ======================================================
  handleAcceptPrivacyPolicy = () => {
    acceptPrivacyPolicy();
    this.setState(() => ({ isActive: true }))
  }

  render() {
    const { isActive } = this.state
    const { text, linkText, buttonText, href } = this.props
    if (isActive) return '';
    return (
      <div className="privacy-policy">
        <div className="content">
          <div className="description">
            <div>
              <p>
                <span>{text}</span>
                <a
                  href={href}
                  target="_blank"
                  className="button-popup"
                >
                  {linkText}
                </a>
              </p>
            </div>
          </div>
          <button onClick={this.handleAcceptPrivacyPolicy} className="button-accept">{buttonText}</button>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/index.js